import { Note, NoteType, Board } from '../types';

export const MOCK_NOTES: Note[] = [
  {
    id: '1',
    type: NoteType.TEXT,
    x: 100,
    y: 100,
    title: 'Design Principles',
    content: 'Work with us and forget about others. Focus on the user.',
    colorTheme: 'beige'
  },
  {
    id: '2',
    type: NoteType.IMAGE,
    x: 450,
    y: 80,
    title: 'Inspiration',
    imageUrl: 'https://picsum.photos/400/300',
    colorTheme: 'white'
  },
  {
    id: '3',
    type: NoteType.TEXT,
    x: 100,
    y: 400,
    title: 'Motivation',
    content: 'You control your life, No one else. Keep pushing forward.',
    colorTheme: 'yellow'
  },
  {
    id: '4',
    type: NoteType.PLANNER,
    x: 800,
    y: 150,
    title: 'Daily Schedule',
    content: 'Focus on deep work today.',
    plannerItems: [
      { id: 'p1', time: '09:00 AM', title: 'Daily Standup', completed: true, emoji: '☕' },
      { id: 'p2', time: '10:30 AM', title: 'Design Review', completed: false, emoji: '🎨' },
      { id: 'p3', time: '01:00 PM', title: 'Lunch Break', completed: false, emoji: '🥗' },
      { id: 'p4', time: '02:00 PM', title: 'Deep Work: System Arch', completed: false, emoji: '🧠' },
    ],
    colorTheme: 'white'
  },
  {
    id: '5',
    type: NoteType.LIST,
    x: 500,
    y: 500,
    title: 'Project Goals',
    items: [
      { text: 'Finish Q3 Roadmap', done: true },
      { text: 'Update UI Kit', done: false },
      { text: 'User Testing', done: false }
    ],
    colorTheme: 'blue'
  },
  {
    id: '6',
    type: NoteType.PYTHON,
    x: 600,
    y: 350,
    title: 'Smart View',
    content: '',
    colorTheme: 'white'
  }
];

export const MOCK_BOARDS: Board[] = [
  {
    id: 'default-board',
    title: 'Product Strategy',
    description: 'Q4 Roadmap and Design Inspiration',
    lastEdited: '2h ago',
    notes: MOCK_NOTES,
    edges: [
      { id: 'e1', from: '1', to: '6' },
      { id: 'e2', from: '3', to: '6' },
    ],
    themeColor: 'blue',
    isFavorite: true,
    isDeleted: false
  },
  {
    id: 'marketing-board',
    title: 'Social Media Campaign',
    description: 'Instagram and Twitter Assets',
    lastEdited: '1d ago',
    notes: [
      { id: 'm1', type: NoteType.TEXT, x: 200, y: 200, title: 'Campaign Taglines', content: 'Just Do It. \nThink Different.', colorTheme: 'orange' },
      { id: 'm2', type: NoteType.TODO, x: 500, y: 150, title: 'To Do', content: 'Check analytics', meta: { isActive: true }, colorTheme: 'white' }
    ],
    edges: [],
    themeColor: 'orange',
    isFavorite: false,
    isDeleted: false
  }
];
